import { SelectValue } from './../../_models/selectValue';
import { WebinarVm, WebinarShortVm } from './../../_models/webinar';
import { ApiService } from './../../_services/api.service';
import { Component, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { RowClassArgs, SelectableSettings } from '@progress/kendo-angular-grid';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-webinars',
  templateUrl: './webinars.component.html',
  styleUrls: ['../ohi-university.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WebinarsComponent implements AfterViewInit {

  columns: any[] = [
    { field: 'id', title: 'Webinar ID', width: '40', filter: false, format: '' },
    { field: 'title', title: 'Title', filter: true, format: '' },
    { field: 'airDate', title: 'Date & Time', filter: true, format: '{0:d}' },
    { field: 'isLive', title: 'Live', filter: true, format: '' },
    { field: 'duration', title: 'Duration', filter: false, format: '{0:c}' }];

  timeList: SelectValue[] = [
    { name: 'Not set yet', value: '00:00:00' },
    { name: '8:00AM', value: '08:00:00' },
    { name: '8:30AM', value: '08:30:00' },
    { name: '9:00AM', value: '09:00:00' },
    { name: '9:30AM', value: '09:30:00' },
    { name: '10:00AM', value: '10:00:00' },
    { name: '10:30AM', value: '10:30:00' },
    { name: '11:00AM', value: '11:00:00' },
    { name: '11:30AM', value: '11:30:00' },
    { name: '12:00PM', value: '12:00:00' },
    { name: '12:30PM', value: '12:30:00' },
    { name: '1:00PM', value: '13:00:00' },
    { name: '1:30PM', value: '13:30:00' },
    { name: '2:00PM', value: '14:00:00' },
    { name: '2:30PM', value: '14:30:00' },
    { name: '3:00PM', value: '15:00:00' },
    { name: '3:30PM', value: '15:30:00' },
    { name: '4:00PM', value: '16:00:00' },
    { name: '4:30PM', value: '16:30:00' },
    { name: '5:00PM', value: '17:00:00' },
    { name: '5:30PM', value: '17:30:00' },
    { name: '6:00PM', value: '18:00:00' }];

  timeZoneList: SelectValue[] = [
    { name: 'Eastern Standard Time', value: 1 },
    { name: 'Central Daylight Time', value: 2 },
    { name: 'Mountain Daylight Time', value: 3 },
    { name: 'Pacific Daylight Time', value: 4 },
    { name: 'Alaska Daylight Time', value: 5 }
  ];

  gridData: any;
  selectedWebinar: WebinarShortVm;
  activeWebinar: WebinarVm = new WebinarVm();
  saving: boolean = false;
  selectableSettings: SelectableSettings;
  imageList: SelectValue[];

  constructor(
    private apiService: ApiService,
    private datePipe: DatePipe) {

    this.selectableSettings = {
      checkboxOnly: false,
      mode: 'single'
    };

  }


  ngAfterViewInit(): void {
    this.apiService.getWebinarThumbnailImages().subscribe(data => {
      this.imageList = data.map((v, i, a) => { return { name: v, value: i }});       
      console.log(this.imageList);
    });

    this.loadWebinars();
  }

  loadWebinars() {
    this.apiService.getWebinarList().subscribe((data) => {
      this.gridData = data.sort((a, b) => new Date(b.airDate).getTime() - new Date(a.airDate).getTime());  
      console.log(data);    
    });
  }

  getHasErrors() {
    const result = 
      !this.activeWebinar ||
      !this.activeWebinar.title ||
      !this.activeWebinar.airDate ||
      !this.activeWebinar.airTime ||
      !this.activeWebinar.airTimeZoneId;
    return result;
  }

  gridCallback(context: RowClassArgs) {
    return { isLive: context.dataItem.isLive };
  }

  cellClickHandler({ sender, rowIndex, columnIndex, dataItem, isEdited }) {
    if (this.selectedWebinar) {
      this.selectedWebinar.isCurrent = false;
    }
    this.selectedWebinar = dataItem;
    this.selectedWebinar.isCurrent = true;

    this.apiService.getWebinar(dataItem.id).subscribe((webinar) => {
      this.activeWebinar = webinar;      
    })
  }

  addWebinar() {
    this.activeWebinar = new WebinarVm();    
  }

  saveWebinar() {
    //Build webinar air date AND time 
    this.activeWebinar.airDate = new Date(`${this.datePipe.transform(this.activeWebinar.airDate, 'yyyy-MM-dd')}T${this.activeWebinar.airTime}+0000`);
    //show progress
    this.saving = true;
    this.apiService.saveWebinar(this.activeWebinar).subscribe((response) => {
      if (response.code === 200) {
        this.activeWebinar = response.webinar;
          this.loadWebinars(); 
      }
      console.log(response);
      //hide progress
      this.saving = false;
      //show alert
    })
  }
}
